import { render, staticRenderFns } from "./BudgetObjectiveInput.vue?vue&type=template&id=72b5e7df&"
import script from "./BudgetObjectiveInput.vue?vue&type=script&lang=js&"
export * from "./BudgetObjectiveInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports